import { memo } from 'react';
import {
  Box,
  GridedFillContent,
  GridedFullContent,
  Modal,
  theme,
} from '@capitalise/ui-design-system';
import FundingSearchBanner from '../FundingSearchBanner';
import useMediaQuery from '../../hooks/useMediaQuery';
import PropTypes from 'prop-types';
import useSideBarBanner from './useSideBarBanner';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from 'HOC/withAuth';
import { CountryList } from 'enums/country';
import { CompanyBusinessType } from 'enums/company-type';
import styled from 'styled-components';
import { use100vh } from 'react-div-100vh';

export const SIDE_MENU_WIDTH = 264;

const WhiteGridedFullContent = styled(GridedFullContent)`
  background-color: white;
`;

const ResponsiveSideMenu = ({ open, onClose, children }) => {
  const { isMobile } = useMediaQuery();
  const { pathname } = useLocation();
  const { isPro, user } = useAuthContext();
  const height = use100vh();

  const countryCode = user?.locale?.countryCode;
  const companyType = user?.company?.type;
  const isGB = countryCode === CountryList.GREAT_BRITAIN;
  const isLLPorLimited = [
    CompanyBusinessType.limitedCompany,
    CompanyBusinessType.llp,
    CompanyBusinessType.limitedLiabilityPartnership,
  ].includes(companyType);

  const shouldDisplayCreditProfile = isLLPorLimited && isGB;

  const bannerProps = useSideBarBanner(pathname, isPro, shouldDisplayCreditProfile);

  const MenuContent = () => {
    return (
      <WhiteGridedFullContent
        flexDirection="column"
        width={isMobile ? '100%' : `${SIDE_MENU_WIDTH}px`}
        py="xsmall"
      >
        <GridedFillContent position="relative" pb="small">
          {children}
        </GridedFillContent>
        <Box position="relative">
          <Box
            position="absolute"
            top={`-${theme.sizes.small}`}
            width="100%"
            height="small"
            background="linear-gradient(180deg, rgba(255, 255, 255, 0) -70.45%, rgba(255, 255, 255, 0.1) -1.39%, rgba(255, 255, 255, 0.7) 8.91%, #FFFFFF 81.17%);"
          />
          <FundingSearchBanner {...bannerProps} />
        </Box>
      </WhiteGridedFullContent>
    );
  };

  return (
    <>
      {!isMobile && <MenuContent />}
      {isMobile && open && (
        <Modal label="modal-menu" position="fixed" zIndex="18" height={`${height}px`}>
          <Box
            display="flex"
            position="relative"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            width="100%"
            height="100%"
            backgroundColor="rgba(0, 0, 0, 0.3)"
            onClick={() => onClose()}
          />
          <Box
            position="absolute"
            top="0"
            bottom="0"
            width="85%"
            height="100%"
            backgroundColor="white"
            display="grid"
          >
            <MenuContent />
          </Box>
        </Modal>
      )}
    </>
  );
};

ResponsiveSideMenu.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default memo(ResponsiveSideMenu);
